import { render, staticRenderFns } from "./FlyerValidityDates.vue?vue&type=template&id=5ecec1ea&scoped=true&"
import script from "./FlyerValidityDates.vue?vue&type=script&lang=js&"
export * from "./FlyerValidityDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecec1ea",
  null
  
)

export default component.exports